<div class="ai-breadcrumbs">
    <ul>
        <li class="ai-breadcrumbs__home"><a href="#">Home</a></li>
        @for (item of items(); track item.label) {
            <li class="ai-breadcrumbs__item">
                <a [href]="item.link">{{ item.label }}</a>
            </li>
        }
    </ul>
</div>
